import { HolisticScore } from '../../../commonTypes/evaluation/calculate.types';

interface EvaluationDiagramProps {
    chartData: HolisticScore | null;
    evaluateeImage?: string;
}

export default function EvaluationDiagram({ chartData }: EvaluationDiagramProps) {
    if (!chartData) return null;

    const mapScoreToPixelPosition = (score: number): number => {
        return ((score + 1) / 2) * 100;
    };

    const culturalPercentage = mapScoreToPixelPosition(chartData.culturalScore.finalScore);
    const technicalPercentage = mapScoreToPixelPosition(chartData.technicalScore.finalScore);

    const mapScoreToCell = (score: number): number => {
        if (score < -0.33) return 0;
        if (score < 0.33) return 1;
        return 2;
    };

    const culturalCell = mapScoreToCell(chartData.culturalScore.finalScore);
    const technicalCell = mapScoreToCell(chartData.technicalScore.finalScore);

    const labels = ['Negative', 'Neutral', 'Positive'];

    const formatScore = (score: number): string => {
        return score.toFixed(2);
    };

    return (
        <div className="evaluation-diagram">
            <div className="evaluation-diagram__x-axis">
                <p>TECHNICAL</p>
            </div>
            <div className="evaluation-diagram__grid" style={{ overflow: 'visible' }}>
                {/* Y-axis labels (Technical) */}
                <div className="evaluation-diagram__y-labels">
                    <div className="evaluation-diagram__y-label">Positive</div>
                    <div className="evaluation-diagram__y-label">Neutral</div>
                    <div className="evaluation-diagram__y-label">Negative</div>
                </div>

                <div className="evaluation-diagram__cells" style={{ overflow: 'visible', position: 'relative' }}>
                    <div
                        className="evaluation-diagram__marker"
                        style={{
                            left: `${culturalPercentage}%`,
                            bottom: `${technicalPercentage}%`,
                            position: 'absolute',
                            zIndex: 10,
                        }}
                    >
                        <div className="evaluation-diagram__dot" />
                        <div className="evaluation-diagram__tooltip">
                            <div>Cultural Score: {formatScore(chartData.culturalScore.finalScore)}</div>
                            <div>Technical Score: {formatScore(chartData.technicalScore.finalScore)}</div>
                        </div>
                    </div>

                    {[2, 1, 0].map(techIndex => (
                        <div key={techIndex} className="evaluation-diagram__row">
                            {[0, 1, 2].map(cultIndex => {
                                const isActiveCell = cultIndex === culturalCell && techIndex === technicalCell;
                                const isPositiveZone = cultIndex === 2 && techIndex === 2;

                                return (
                                    <div
                                        key={`${techIndex}-${cultIndex}`}
                                        className={`evaluation-diagram__cell ${isPositiveZone ? 'evaluation-diagram__cell--positive' : ''} ${
                                            isActiveCell ? 'evaluation-diagram__cell--active' : ''
                                        }`}
                                    />
                                );
                            })}
                        </div>
                    ))}
                </div>
            </div>
            {/* X-axis labels (Cultural) */}
            <div className="evaluation-diagram__x-axis">
                <div className="evaluation-diagram__x-labels">
                    {labels.map(label => (
                        <div key={label} className="evaluation-diagram__x-label">
                            {label}
                        </div>
                    ))}
                </div>
                <div className="evaluation-diagram__x-axis-bottom">
                    <p> CULTURAL </p>
                </div>
            </div>
        </div>
    );
}
